import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { installAxeptioSdkGuard } from './app/shared/extensions/axeptio-sdk-guard';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

installAxeptioSdkGuard();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
